import UserStore from "../components/User/UserStore";
import { pluralize, camelize } from "../../shared/helpers";
import ResponseStore from "@shared/stores/ResponseStore";

export default class {
  constructor (resourceName, baseUrl = () => `/api/v4/users/${UserStore.state.user.id}`) {
    this.resourceName = resourceName;
    this.baseUrl = baseUrl;

    this.collectionName = pluralize(resourceName);

    this.resourceNameCamelized = camelize(this.resourceName);
    this.collectionNameCamelized = camelize(this.collectionName);

    this.state = {};

    this.state[this.resourceNameCamelized] = null;
    this.state[this.collectionNameCamelized] = [];
  }

  async fetchAll () {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}`
    );

    this._onResponseReceived(response);

    const responseJSON = await response.json();

    this.state[this.collectionNameCamelized] = responseJSON[this.collectionName];
  }

  async fetch (id) {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}/${id}`
    );

    this._onResponseReceived(response);

    const responseJSON = await response.json();

    this.state[this.resourceNameCamelized] = responseJSON[this.resourceName];
  }

  async create () {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}`, {
        body: new FormData(document.getElementById("form-card")),
        method: "POST"
      });

    this._onResponseReceived(response);

    const responseJSON = await response.json();

    this.state[this.resourceNameCamelized] = responseJSON[this.resourceName];

    ResponseStore.finishProcessing();

    return responseJSON;
  }

  async update (id) {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}/${id}`, {
        body: new FormData(document.getElementById("form-card")),
        method: "PUT"
      });

    this._onResponseReceived(response);

    const responseJSON = await response.json();

    this.state[this.resourceNameCamelized] = responseJSON[this.resourceName];

    ResponseStore.finishProcessing();

    return responseJSON;
  }

  async delete (id) {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}/${id}`, {
        method: "DELETE"
      });

    this._onResponseReceived(response);

    this.state[this.resourceNameCamelized] = {};

    return response.json();
  }

  async collection (name) {
    const response = await fetch(
      `${this.baseUrl()}/${this.collectionName}/${name}`
    );

    this._onResponseReceived(response);

    const responseJSON = await response.json();

    this.state[name] = responseJSON[this.collectionName];

    return this.state[name];
  }

  updateObject (responseJSON) {
    this.state[this.resourceNameCamelized] = responseJSON[this.resourceName];
  }

  _onResponseReceived (response) {
    this._handleUnauthorizedRequest(response.status);
  }

  _handleUnauthorizedRequest (responseStatus) {
    if (responseStatus === 401) {
      location.reload();
    }
  }
}
